export default "<ngx-spinner type = \"ball-clip-rotate-pulse\"></ngx-spinner>\n<router-outlet></router-outlet>";